import React, { Component } from "react";
import { MdExpandMore, MdInfo } from "react-icons/md";
import Moment from "react-moment";
import showInfo from "./show_info";

class ListOldItems extends Component {
  render() {
    const { items } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div className="item-content">
            <div
              className="card-panel white lighten-5 z-depth-1"
              style={{
                width: "100%",
                margin: "auto",
                height: "auto",
                display: "block",
                position: "relative",
                boxShadow:
                  "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                fontSize: "1.1rem",
                marginTop: "153px"
              }}
            >
              {items.length > 0 ? (
                items.map((item, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="accordion md-accordion accordion-blocks"
                      id="accordionEx78"
                      role="tablist"
                      aria-multiselectable="true"
                      style={{
                        alignContent: "left",
                        backgroundColor: "white",
                        boxShadow:
                          "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                        display: "block",
                        margin: "auto"
                      }}
                    >
                      <div className="card white" id={"card" + i}>
                        <div
                          className="card-header"
                          role="tab"
                          id={"headingUnfiled" + i}
                          style={{
                            backgroundColor: "#343a40"
                          }}
                        >
                          <a
                            data-toggle="collapse"
                            data-parent={"#card" + i}
                            href={"#collapseUnfiled" + i}
                            aria-expanded="true"
                            aria-controls="collapseUnfiled"
                          >
                            <h5 className="mt-4 mb-0">
                              <span style={{ color: "white" }}>
                                Item - <i>Arquivado</i>
                                <p className="left" style={{ color: "white" }}>
                                  ID: {item.id_item}
                                </p>
                                <p className="right" style={{ color: "white" }}>
                                  <MdExpandMore />
                                </p>
                              </span>
                            </h5>
                          </a>
                        </div>
                        <div
                          id={"collapseUnfiled" + i}
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={"headingUnfiled" + i}
                          data-parent={"#card" + i}
                        >
                          <div className="card-body">
                            <React.Fragment>
                              <div
                                className="row justify-content-center"
                                style={{
                                  display: "block",
                                  margin: "auto",
                                  width: "100%"
                                }}
                              >
                                <div className="col s12">
                                  <table className="table table-adapt-query table-sm table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">ID Malote</th>
                                        <th scope="col">Malote - Criação</th>
                                        <th scope="col">Malote - Conclusão</th>
                                        <th scope="col">Remetente</th>
                                        <th scope="col">Destinatário</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Descrição</th>
                                        <th scope="col">Item - Arquivamento</th>
                                        <th scope="col">
                                          <i>Info</i>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr key={i}>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {item.id_transacao}
                                        </td>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          <Moment format="DD/MM/YYYY">
                                            {item.created_on}
                                          </Moment>
                                        </td>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          <Moment format="DD/MM/YYYY">
                                            {item.concluded_on}
                                          </Moment>
                                        </td>
                                        <td>
                                          {item.usuario_remetente
                                            .toUpperCase()
                                            .replace(".", " ")}
                                        </td>
                                        <td>
                                          {item.destino
                                            .toUpperCase()
                                            .replace(".", " ")}
                                        </td>
                                        <td>{item.tipo.toUpperCase()}</td>
                                        <td>
                                          {item.descricao &&
                                            (item.descricao.length <= 15 ? (
                                              item.descricao
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_descricao"
                                                maxLength="100"
                                                value={item.descricao}
                                                readOnly
                                              />
                                            ))}
                                        </td>
                                        <td>
                                        <Moment format="DD/MM/YYYY">
                                            {item.updated_at !== "0000-00-00 00:00:00" ? item.updated_at : item.archived_on}
                                          </Moment>
                                        </td>
                                        <td>
                                          <MdInfo
                                            style={{
                                              fontSize: "1.2rem"
                                            }}
                                            onClick={() => showInfo(item)}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <p style={{ paddingTop: "25px" }}>
                  Nenhum registro encontrado.
                </p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ListOldItems;
